<script setup lang="ts">
import type { CollapsibleRootEmits, CollapsibleRootProps } from 'reka-ui'
import { CollapsibleRoot, useForwardPropsEmits } from 'reka-ui'

/**
 * shadcn-vue `Collapsible` on Reka's `CollapsibleRoot`: a disclosure that is closed unless asked to start open
 * (`defaultOpen`) or held open by a parent (`open` / `update:open`). It draws no chrome of its own; the header
 * is `CollapsibleTrigger` and the hidden part is `CollapsibleContent`, which is not drawn while closed.
 */
const props = defineProps<CollapsibleRootProps>()
const emits = defineEmits<CollapsibleRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <CollapsibleRoot v-slot="slotProps" data-slot="collapsible" v-bind="forwarded">
    <slot v-bind="slotProps" />
  </CollapsibleRoot>
</template>
